(function ($, Drupal) {
  Drupal.behaviors.printImageFix = {
    attach: function (context, settings) {
      window.addEventListener('beforeprint', () => {
        document.querySelectorAll('img[loading="lazy"]').forEach(img => {
          img.loading = 'eager';
        });
      });
    }
  };
})(jQuery, Drupal);
